module.exports = __webpack_public_path__ + "img/cloudsploit.1d7d7263.png";